import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, InputAdornment, IconButton } from '@mui/material'

import { FormError } from '../../types/common.types'
import FaEye from '../../assets/icons/eye-showed-icon.svg'
import { textFieldWhiteBg } from '../../theme/custom-styles'
import FaEyeSlash from '../../assets/icons/eye-slash-icon.svg'

const CurrentPasswordForm = ({
  errors,
  systemUserCurrentPassword,
  handleSetSystemUserCurrentPassword
}: {
  errors: FormError
  systemUserCurrentPassword: string
  handleSetSystemUserCurrentPassword: (currentPasswordToSet: string) => void
}) => {
  const { t } = useTranslation(['account-management'])
  const [currentPasswordVisible, setCurrentPasswordVisible] = useState<boolean>(false)

  return (
    <div className="account-management-current-password-form-container">
      <div className="account-management-current-password-form-text">{t('changeAccountPasswordModal.currentPasswordForm.mainInstruction')}</div>
      <TextField
        fullWidth
        variant="standard"
        label={t('changeAccountPasswordModal.currentPasswordForm.fields.password')}
        sx={textFieldWhiteBg}
        value={systemUserCurrentPassword || ''}
        error={!!errors.systemUserCurrentPassword}
        helperText={errors.systemUserCurrentPassword}
        type={currentPasswordVisible ? 'text' : 'password'}
        onChange={(event) => handleSetSystemUserCurrentPassword(event.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                aria-label="toggle password visibility"
                sx={{ color: '#15B79E', right: '10px', bottom: '3px' }}
                onClick={() => setCurrentPasswordVisible((visible) => !visible)}
              >
                {currentPasswordVisible ? (
                  <img
                    src={FaEyeSlash}
                    alt="eye-slash-icon"
                    style={{ width: '28px', height: '28px' }}
                  />
                ) : (
                  <img
                    src={FaEye}
                    alt="eye-icon"
                    style={{ width: '28px', height: '28px' }}
                  />
                )}
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    </div>
  )
}

export default CurrentPasswordForm
